import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

import { AccountAuthService } from '../account-auth.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['../auth-form.scss'],
  standalone: false,
})
export class ForgotPasswordComponent implements OnInit {
  readonly email = new FormControl('', [Validators.required, Validators.email]);
  busy = false;
  sentTo: string | null = null;
  error: string | null = null;

  constructor(private auth: AccountAuthService, private route: ActivatedRoute, private cdr: ChangeDetectorRef) {}

  ngOnInit(): void {
    const email = this.route.snapshot.queryParamMap.get('email');
    if (email) this.email.setValue(email);
  }

  submit(): void {
    if (this.busy) return;
    if (this.email.invalid) {
      this.email.markAsTouched();
      return;
    }
    const email = this.email.value!.trim();
    this.busy = true;
    this.error = null;
    this.auth.forgotPassword(email).subscribe({
      next: () => {
        this.busy = false;
        this.sentTo = email;
        this.cdr.detectChanges();
      },
      error: (err) => {
        this.busy = false;
        this.error = this.auth.toError(err).message;
        this.cdr.detectChanges();
      },
    });
  }

  again(): void {
    this.sentTo = null;
  }
}
